import { render, staticRenderFns } from "./DarkLayout.vue?vue&type=template&id=5f99f850"
import script from "./DarkLayout.vue?vue&type=script&lang=js"
export * from "./DarkLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports